import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Grid } from "@mui/material";
import { FormDynamic, Alert } from "../../../components";
import BackdropComponent from "../../../components/BackDrop";
import {
  RegisterDocumentFields,
  IntegrateDocumentToSign,
} from "../../../store/actions";
import { TemplatesServices } from "../../../services/TemplatesServices";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export const DynamicQuestionnaire = (props) => {
  const [listDocumentFieldData, setlistDocumentFieldData] = useState([]);
  const userLogoutClose = true;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const rolUser = useSelector(
    (state) =>
      state.Authentication?.items?.UserLoginData?.SecurityLoginData?.Roles[0]
        ?.Code
  );

  // Control de estados
  const ListDocumentsMetadataState = useSelector(
    (state) => state.File?.item?.DocumentFields
  );
  const RegisterDocumentFieldsState = useSelector(
    (state) => state.RegisterDocumentFieldsData
  );
  const folioIdSolicitudState = useSelector(
    (state) => state.File?.item?.FileData?.Id
  );
  const IntegrateDocumentToSignState = useSelector(
    (state) => state.IntegrateDocumentToSignData
  );

  const folioIdSolicitud =
    folioIdSolicitudState ?? sessionStorage.getItem("FileId");
  //Peticiones a apis
  const dispatch = useDispatch();
  console.log("ListDocumentsMetadataState", ListDocumentsMetadataState);

  useEffect(() => {
    if (props.TemplateData === true) {
      traerMetadatosTemplate();
    } else {
      if (ListDocumentsMetadataState?.length > 0) {
        var newArrayDocs = ListDocumentsMetadataState?.map((item) => {
          console.log("++++++++---item--++++++: ", item);
          return {
            ...item,
            Id: `${item.Name}_${item.DocumentField_Id}`,
          };
        });
        setlistDocumentFieldData(newArrayDocs);
      }
    }
  }, [ListDocumentsMetadataState, props.TemplateData]);

  const traerMetadatosTemplate = async () => {
    const templateService = TemplatesServices.getInstance();
    const response = await templateService.GetFieldsCaptureParticipant({
      File_Id: folioIdSolicitudState,
    });
    console.log("RESPONSEDATA", response);
    if (response.Body !== null && response.Body.DocumentFields.length > 0) {
      var newArrayDocs = response.Body.DocumentFields?.map((item) => {
        console.log("++++++++---item--++++++: ", item);
        return {
          ...item,
          Id: `${item.Name}_${item.DocumentField_Id}`,
        };
      });
      setlistDocumentFieldData(newArrayDocs);
    }
  };

  useEffect(() => {
    if (
      RegisterDocumentFieldsState.items !== undefined &&
      RegisterDocumentFieldsState.items !== null &&
      loading
    ) {
      if (props.TemplateData === true) {
        dispatch(RegisterDocumentFields("", true));
        setLoading(false);
        Alert({
          icon: "success",
          text: "Datos guardados correctamente.",
          okbtntext: "Aceptar",
        });
        if (rolUser === "Operador" && userLogoutClose === true) {
          sessionStorage.clear();
          localStorage.clear();
          navigate("/auth/login");
          window.location.reload();
        } else {
          navigate("/inbox/files");
        }
      } else {
        dispatch(RegisterDocumentFields("", true));
        dispatch(
          IntegrateDocumentToSign({
            File_Id: folioIdSolicitud,
            IsMasive: false,
          })
        );
      }
    } else if (
      RegisterDocumentFieldsState.error !== undefined &&
      RegisterDocumentFieldsState.error !== null &&
      loading
    ) {
      setLoading(false);
      dispatch(RegisterDocumentFields("", true));
      Alert({
        icon: "error",
        text: RegisterDocumentFieldsState.error,
        okbtntext: "Aceptar",
      });
    }
  }, [RegisterDocumentFieldsState]);

  useEffect(() => {
    if (props.TemplateData === true) {
      return null;
    } else {
      if (
        IntegrateDocumentToSignState.items !== undefined &&
        IntegrateDocumentToSignState.items !== null &&
        loading
      ) {
        setLoading(false);
        dispatch(IntegrateDocumentToSign("", true));
        Alert({
          icon: "success",
          text: "Datos guardados correctamente.",
          okbtntext: "Aceptar",
        });
        if (rolUser === "Operador" && userLogoutClose === true) {
          sessionStorage.clear();
          localStorage.clear();
          navigate("/auth/login");
          window.location.reload();
        } else {
          navigate("/inbox/files");
        }
      } else if (
        IntegrateDocumentToSignState.error !== undefined &&
        IntegrateDocumentToSignState.error !== null &&
        loading
      ) {
        setLoading(false);
        dispatch(IntegrateDocumentToSign("", true));
        Alert({
          icon: "error",
          text: IntegrateDocumentToSignState.error,
          okbtntext: "Aceptar",
        });
      }
    }
  }, [IntegrateDocumentToSignState]);

  const handleConfirm = (formData) => {
    console.log("formData", formData);
    setLoading(true);
    const MetaDataFormat = listDocumentFieldData.map((itemField) => {
      return {
        Code: itemField.Code,
        Value: reformateData(itemField, formData),
      };
    });
    console.log("MetaDataFormat", MetaDataFormat);
    let request = {
      File_Id: folioIdSolicitud,
      DocumentFieldsUpdate: MetaDataFormat,
      IsMasive: false,
      ContinueWorkFlow: props.TemplateData === true ? true : false,
    };

    console.log("request", request);
    dispatch(RegisterDocumentFields(request));
  };

  const reformateData = (itemField, formData) => {
    let dataValue = formData[`${itemField.Name}_${itemField.DocumentField_Id}`];
    console.log("formData", dataValue);

    if (itemField.DataType === "Currency") {
      return "$" + dataValue;
    } else if (
      itemField.DataType === "DateTime" &&
      dataValue !== null &&
      dataValue !== "" &&
      dataValue !== undefined
    ) {
      console.log(
        "formData EN FECHA",
        itemField.DataType,
        dataValue,
        moment.utc(dataValue).local().format("DD-MM-YYYY hh:mm:ss A")
      );
      return moment.utc(dataValue).local().format("DD-MM-YYYY hh:mm:ss A");
    } else if (
      itemField.DataType === "Date" &&
      dataValue !== null &&
      dataValue !== "" &&
      dataValue !== undefined
    ) {
      console.log(
        "formData EN FECHA",
        itemField.DataType,
        dataValue,
        moment.utc(dataValue).local().format("DD-MM-YYYY hh:mm:ss A")
      );
      return moment.utc(dataValue).local().format("DD-MM-YYYY");
    } else {
      return dataValue;
    }
  };

  const handleCancel = (item) => {
    props.setIsCuestionaryActive(false);
  };

  return (
    <Fragment>
      <BackdropComponent loading={loading} />
      <Grid
        container
        justifyContent={"rigth"}
        sx={{ mb: 1, pb: 1, borderBottom: "1px solid #898B8D4D" }}
      >
        <Grid item xs={12} md={10} lg={10}>
          <Box sx={{ mt: 1.5 }}>
            <Typography variant="caption" sx={{ fontWeight: 500, mb: 2 }}>
              Estatus:{" "}
              <span style={{ color: " #C20E30" }}>Firma de documentos </span>
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={10} md={10} sx={{ mt: 1, ml: 3 }}>
          <Typography variant="body1" sx={{ fontWeight: 300 }}>
            La información capturada será utilizada para llenar el documento que
            será firmado
          </Typography>
        </Grid>
        {listDocumentFieldData?.length > 0 ? (
          <FormDynamic
            DataControls={listDocumentFieldData}
            handleConfirm={handleConfirm}
            ConfirmButtonText={"Enviar"}
            handleCancel={handleCancel}
          />
        ) : null}
      </Grid>
    </Fragment>
  );
};
